import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Paper,
  ButtonGroup,
  Button,
  IconButton,
  Divider,
  Box
} from '@mui/material';
import {
  Delete as DeleteIcon,
  Add as AddIcon
} from '@mui/icons-material';
import { selectSelectedList, removeFromSelectedList, clearSelectedList } from '../../store/slices/tickers.slice';
import TickerChip from '../../components/TickerChip';
import Logo from '../../components/Graphics/Logo';
import {useTickerSearchIndex} from "../../modules/Search/useTickerSearchIndex";
import { useFeatures } from '../../features/useFeatures';

const ScreenerCart = ({ defaultType = 'stock' }) => {
  const dispatch = useDispatch();
  const { initializeSma } = useFeatures();
  const [activeType, setActiveType] = useState(defaultType);

  // Get both lists
  const selectedStocks = useSelector(state => selectSelectedList(state, 'stockSelectedList'));
  const selectedEtfs = useSelector(state => selectSelectedList(state, 'etfSelectedList'));

  const { tickers } = useTickerSearchIndex([...selectedStocks || [], ...selectedEtfs || []]);

  // Get active list based on type
  const activeList = activeType === 'etf' ? selectedEtfs : selectedStocks;
  const listField = activeType === 'etf' ? 'etfSelectedList' : 'stockSelectedList';

  const handleRemoveSymbol = (symbol) => {
    dispatch(removeFromSelectedList({
      listField,
      symbols: symbol
    }));
  };

  const handleClearType = () => {
    dispatch(clearSelectedList({
      listField
    }));
  };

  const handleCreateSma = () => {
    if (selectedEtfs.length > 0) {
      initializeSma(selectedEtfs);
    }
  };

  // Hide if no selections at all
  if (selectedStocks.length === 0 && selectedEtfs.length === 0) return null;

  return (
    <Paper
      elevation={3}
      className="fixed bottom-0 left-0 right-0 z-50"
      sx={{
        borderTop: '1px solid rgba(0,0,0,0.1)',
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(8px)',
      }}
    >
      <div className="flex items-center justify-between px-4 py-2">
        <div className="flex items-center space-x-4">
          <ButtonGroup size="small">
            <Button
              variant={activeType === 'stock' ? 'contained' : 'outlined'}
              onClick={() => setActiveType('stock')}
              className="min-w-[100px]"
            >
              Stocks ({selectedStocks.length})
            </Button>
            <Button
              variant={activeType === 'etf' ? 'contained' : 'outlined'}
              onClick={() => setActiveType('etf')}
              className="min-w-[100px]"
            >
              ETFs ({selectedEtfs.length})
            </Button>
          </ButtonGroup>
          <Divider orientation="vertical" flexItem />
          <div className="flex flex-1 gap-2 overflow-x-auto px-4" style={{ maxWidth: 'calc(100vw - 500px)' }}>
            {activeList.map(symbol => (
              <div key={symbol} className="relative inline-flex">
                <TickerChip ticker={tickers.find((x)=>x.symbol===symbol)||symbol} />
                <IconButton
                  size="small"
                  className="absolute -top-1 -right-1"
                  onClick={() => handleRemoveSymbol(symbol)}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </div>
            ))}
          </div>
        </div>
        <div className="flex items-center space-x-2">
          {selectedEtfs.length > 0 && (
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={handleCreateSma}
              size="small"
            >
              Create SMA
            </Button>
          )}
          <IconButton onClick={handleClearType} size="small">
            <DeleteIcon />
          </IconButton>
        </div>
      </div>
    </Paper>
  );
};

export default ScreenerCart;